export const translations = {
  fr: {
    // Navigation
    dashboard: 'Dashboard',
    properties: 'Logements',
    revenue: 'Revenus',
    admin: 'Admin',
    logout: 'Déconnexion',
    
    // Auth
    login: 'Connexion',
    register: 'Créer un compte',
    email: 'Email',
    password: 'Mot de passe',
    fullName: 'Nom complet',
    company: 'Entreprise',
    address: 'Adresse',
    
    // Dashboard
    welcome: 'Bienvenue',
    tasksToComplete: 'Tâches à réaliser',
    calendar: 'Calendrier',
    noTasks: 'Aucune option à mettre en place pour le moment',
    
    // Properties
    myProperties: 'Mes Logements',
    addProperty: 'Ajouter un logement',
    propertyName: 'Nom du logement',
    description: 'Description',
    active: 'Actif',
    
    // Revenue
    myRevenue: 'Mes Revenus',
    yourRevenue: 'Vos revenus',
    appRevenue: 'Revenus app',
    transactions: 'Transactions',
    revenueByProperty: 'Revenus par logement',
    
    // Options
    globalOptions: 'Options Globales',
    addOption: 'Ajouter une option',
    optionName: 'Nom de l\'option',
    conciergePercentage: '% Concierge',
    appPercentage: '% Application',
    
    // Public
    improveYourStay: 'Améliorez votre séjour',
    selectOptions: 'Sélectionnez vos options',
    totalAmount: 'Total',
    pay: 'Payer',
    
    // Common
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    back: 'Retour',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    properties: 'Properties',
    revenue: 'Revenue',
    admin: 'Admin',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Sign up',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    company: 'Company',
    address: 'Address',
    
    // Dashboard
    welcome: 'Welcome',
    tasksToComplete: 'Tasks to Complete',
    calendar: 'Calendar',
    noTasks: 'No options to set up at the moment',
    
    // Properties
    myProperties: 'My Properties',
    addProperty: 'Add Property',
    propertyName: 'Property Name',
    description: 'Description',
    active: 'Active',
    
    // Revenue
    myRevenue: 'My Revenue',
    yourRevenue: 'Your Revenue',
    appRevenue: 'App Revenue',
    transactions: 'Transactions',
    revenueByProperty: 'Revenue by Property',
    
    // Options
    globalOptions: 'Global Options',
    addOption: 'Add Option',
    optionName: 'Option Name',
    conciergePercentage: '% Concierge',
    appPercentage: '% Application',
    
    // Public
    improveYourStay: 'Enhance Your Stay',
    selectOptions: 'Select Your Options',
    totalAmount: 'Total',
    pay: 'Pay',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.fr[key] || key;
};
